module.exports = __webpack_public_path__ + "static/banner-tablet-15de598ee56223f6d970cfbee8bc0108.png";